
export default function EducationSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Formación Académica y Certificaciones
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Respaldo académico de las mejores instituciones médicas de México 
            y certificaciones internacionales en cirugía robótica.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <img 
              src="https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/a52d6be6ac50ee3864cba61d76f1e91a.jpeg"
              alt="Formación Médica Académica"
              className="w-full h-80 object-cover object-top rounded-2xl shadow-2xl"
            />
          </div>
          
          <div className="space-y-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-graduation-cap-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">Médico Cirujano</h3>
                  <p className="text-blue-600 font-semibold">Universidad Veracruzana (UV)</p>
                </div>
              </div>
              <p className="text-gray-600">
                Formación médica integral con especialización en ciencias médicas 
                y fundamentos quirúrgicos en una de las universidades más prestigiosas de México.
              </p>
            </div>
            
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-hospital-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">Especialidad en Urología</h3>
                  <p className="text-green-600 font-semibold">Universidad de Guadalajara (UdeG)</p>
                </div>
              </div>
              <p className="text-gray-600">
                Especialización completa en urología con entrenamiento en las técnicas 
                más avanzadas de cirugía urológica y manejo integral del paciente urológico.
              </p>
            </div>
            
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-award-line text-2xl text-purple-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">Alta Especialidad</h3>
                  <p className="text-purple-600 font-semibold">Universidad Nacional Autónoma de México (UNAM)</p>
                </div>
              </div>
              <p className="text-gray-600">
                Subespecialización en cirugía robótica y técnicas mínimamente invasivas 
                en la máxima casa de estudios de México.
              </p>
            </div>
          </div>
        </div>
        
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-12">
            Certificaciones y Membresías Profesionales
          </h3>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-robot-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Certificación da Vinci</h4>
              <p className="text-sm text-gray-600">Intuitive Surgical</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-green-600"></i>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Consejo Mexicano</h4>
              <p className="text-sm text-gray-600">de Urología</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-2xl text-purple-600"></i>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Sociedad Internacional</h4>
              <p className="text-sm text-gray-600">de Urología</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-flashlight-line text-2xl text-orange-600"></i>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Certificación Láser</h4>
              <p className="text-sm text-gray-600">CO2 y Holmium</p>
            </div>
          </div>
        </div>
        
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">Educación Médica Continua</h3>
          <p className="text-blue-100 mb-6 max-w-3xl mx-auto">
            Participación constante en congresos internacionales, cursos de actualización 
            y entrenamientos en las técnicas más avanzadas de cirugía robótica y láser.
          </p>
          <div className="flex justify-center items-center space-x-8">
            <div className="text-center">
              <div className="text-3xl font-bold">50+</div>
              <div className="text-blue-200 text-sm">Congresos Médicos</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold">25+</div>
              <div className="text-blue-200 text-sm">Certificaciones</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold">10+</div>
              <div className="text-blue-200 text-sm">Años de Experiencia</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
